import { IUserState } from './users.state';
import { createReducer, on } from '@ngrx/store';
import {
  assignProcessPartners,
  assignProcessPartnersFailure,
  assignProcessPartnersSuccess,
  assignSurveyPoints,
  assignSurveyPointsFailure,
  assignSurveyPointsSuccess,
  createUser,
  createUserFailure,
  createUserSuccess,
  loadUserById,
  loadUserByIdFailure,
  loadUserByIdSuccess,
  loadUsers,
  loadUsersFailure,
  loadUsersSuccess,
  updateUser,
  updateUserFailure,
  updateUserSuccess,
} from './users.actions';

export const initialState: IUserState = {
  users: [],
  selectedUser: null,
  loading: false,
  savingLoading: false,
  assignmentLoading: false,
  error: null,
};

export const usersReducer = createReducer(
  initialState,
  on(loadUsers, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(loadUsersSuccess, (state, { users }) => {
    return {
      ...state,
      users,
      loading: false,
    };
  }),
  on(loadUsersFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
  on(loadUserById, (state) => ({ ...state, loading: true })),
  on(loadUserByIdSuccess, (state, { user }) => ({
    ...state,
    selectedUser: user,
    assignmentLoading: false,
    loading: false,
    error: null,
  })),
  on(loadUserByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    assignmentLoading: false,
    error,
  })),
  on(createUser, (state) => ({ ...state, savingLoading: true })),
  on(createUserSuccess, (state, { user }) => ({
    ...state,
    users: [...state.users, user],
    savingLoading: false,
    error: null,
  })),
  on(createUserFailure, (state, { error }) => ({
    ...state,
    savingLoading: false,
    error,
  })),
  on(updateUser, (state) => ({ ...state, savingLoading: true })),
  on(updateUserSuccess, (state, { user }) => ({
    ...state,
    users: state.users.map((u) => (u.id === user.id ? user : u)),
    savingLoading: false,
    error: null,
  })),
  on(updateUserFailure, (state, { error }) => ({
    ...state,
    savingLoading: false,
    error,
  })),
  on(assignProcessPartners, (state) => ({ ...state, assignmentLoading: true })),
  on(assignProcessPartnersSuccess, (state, { user }) => ({
    ...state,
    selectedUser: user,
    assignmentLoading: false,
    error: null,
  })),
  on(assignProcessPartnersFailure, (state, { error }) => ({
    ...state,
    assignmentLoading: false,
    error: error,
  })),
  on(assignSurveyPoints, (state) => ({ ...state, assignmentLoading: true })),
  on(assignSurveyPointsSuccess, (state, { user }) => ({
    ...state,
    selectedUser: user,
    assignmentLoading: false,
    error: null,
  })),
  on(assignSurveyPointsFailure, (state, { error }) => ({
    ...state,
    assignmentLoading: false,
    error: error,
  }))
);
